export function userFormValidator(event, bypassRequiredFields = []){
  event.preventDefault();
  var bool=true;
  var userForm = document.getElementById('userForm');
  var inputs = userForm.getElementsByTagName('input');
  for(var i=0; i<inputs.length;i++){
    let inputField = inputs[i];
    if(inputs[i].required || bypassRequiredFields.find(bypassRequiredField => bypassRequiredField === inputs[i].name)){
    var inputFieldError = document.getElementById(inputs[i].name+'Error');
    inputFieldError.textContent='';
    if(!inputs[i].validity.valid){
      inputFieldError.textContent = inputs[i].validationMessage;
      bool=false;
    }
    if(inputs[i].name=='password_confirmation' || inputs[i].name=='confirmPassword'){
      if(document.getElementById('password').value!==(inputField.value)){
        inputFieldError.textContent='Passwords do not match';
        bool=false;
      }
    }
    }
  }
  return bool;
};

export function inputFocusHandler(e, bypassRequired = false){
  var inputField= e.target;
  if(inputField.required || bypassRequired === true){
    var errorDiv = document.getElementById(inputField.name+'Error');
    errorDiv.textContent = '';
    if(inputField.name=='password_confirmation' || inputField.name=='confirmPassword'){
      if(document.getElementById('password').value!==(inputField.value))
        errorDiv.textContent='Passwords do not match';
    }
    if(inputField.name=='password'){
      let confirmPassword=document.getElementById('confirmPassword');
      var inputFieldError = document.getElementById(confirmPassword.name+'Error');
      if(confirmPassword.value!==(inputField.value)){
        inputFieldError.textContent='Passwords do not match';
      }
      else{
        inputFieldError.textContent='';
      }
    }
    if(!inputField.validity.valid){
      errorDiv.textContent = inputField.validationMessage;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/userFormValidate.js